import React, { Suspense } from 'react'
import { Loader, BasePageProps, Content } from '@/tumeloshared'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { changeTitle } from './changeTitle'

const PortfolioLazy = React.lazy(() => import('./PortfolioLazy'))

type Props = BasePageProps

const PortfolioPage: React.FC<Props> = ({ pageTitle }) => {
  changeTitle(pageTitle)

  return (
    <ErrorBoundary>
      <Content>
        <Suspense fallback={<Loader />}>
          <PortfolioLazy />
        </Suspense>
      </Content>
    </ErrorBoundary>
  )
}

export default PortfolioPage
